import { render, staticRenderFns } from "./SimulationView.vue?vue&type=template&id=b2e290ba&scoped=true&"
import script from "./SimulationView.vue?vue&type=script&lang=js&"
export * from "./SimulationView.vue?vue&type=script&lang=js&"
import style0 from "./SimulationView.vue?vue&type=style&index=0&id=b2e290ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e290ba",
  null
  
)

export default component.exports